// extracted by mini-css-extract-plugin
module.exports = {"form":"QuoteForm_form__21qC2","loading":"QuoteForm_loading__3i7CL","control":"QuoteForm_control__2f8QY","actions":"QuoteForm_actions__2n135"};